import React, { useState } from 'react';
import { AccountManagementRes } from '../columns';
import Icons from '../../../../../components/Common/Icons/Icons';
import PageSubHeader from '../../../Common/PageSubHeader';
import CreateAccountForm from './Form';
import AccountManagementPrevAccount from './Prev';

const defaultValues: AccountManagementRes = {
  accountName: '',
  accountNumber: '',
  accountType: 'selectOne',
  id: '',
  subRows: [],
  status: 'active',
};

export type InvalidFields = Partial<Record<keyof AccountManagementRes, boolean>>;

function AccountManagementCreateAccount() {
  const [state, setState] = useState<AccountManagementRes>(defaultValues);
  const [showPrev, setShowPrev] = useState<boolean>(false);

  const [invalidFields, setInvalidFields] = useState<InvalidFields>({
    accountName: false,
    accountNumber: false,
  });

  const handleInputChange = (key: keyof AccountManagementRes, value: string) => {
    setState({ ...state, [key]: value });
    handleValidate(key, value);
  };

  const handleSelectChange = (value: string) => {
    setState({
      ...state,
      accountType: value,
    });
  };

  const handleReset = () => {
    setState(defaultValues);
    setShowPrev(false);
    setInvalidFields({
      accountName: false,
      accountNumber: false,
    });
  };

  const handleSubmit = () => {
    const newInvalidFields: InvalidFields = { ...invalidFields };

    Object.entries(state).forEach(([key, value]) => {
      if (key in invalidFields) {
        newInvalidFields[key as keyof AccountManagementRes] = !value.length;
      }
    });

    setInvalidFields(newInvalidFields);

    if (Object.values(newInvalidFields).some(el => el)) {
      return;
    }

    setShowPrev(true);
  };

  const handleValidate = (key: keyof AccountManagementRes, value: string) => {
    setInvalidFields(prevState => ({ ...prevState, [key]: !value.length }));
  };

  const handleBack = () => {
    setShowPrev(false);
  };

  return (
    <div>
      <PageSubHeader
        leftContent={
          <div className="flex items-center gap-2">
            <Icons.UserAccount className="size-6" />
            <span>Account Management</span>
          </div>
        }
        breadcrumbs={[
          { path: '/infoTrac/', label: <Icons.HomeOutlined />, disableBg: true },
          { path: '/infoTrac', label: 'InfoTRAC' },
          { path: '/infoTrac/account-management', label: 'Account Management' },
        ]}
      />

      <div className="mt-[30px] bg-[#F8F9FD] shadow-lg max-w-[690px] rounded-lg p-[30px] mx-auto self-center">
        <div className="mb-[25px] flex gap-[20px] items-start">
          <div className="bg-primary p-[5px] rounded-lg">
            <Icons.TextEditFilled className="[&_path]:fill-white w-[24px] h-[24px]" />
          </div>
          <div>
            <div className="font-bold text-xl leading-[24px]">Create Account</div>
            <div className="opacity-60">Some text description</div>
          </div>
        </div>
        {!showPrev ? (
          <CreateAccountForm
            state={state}
            handleReset={handleReset}
            handleSelectChange={handleSelectChange}
            handleSubmit={handleSubmit}
            handleInputChange={handleInputChange}
            invalidFields={invalidFields}
            handleValidate={handleValidate}
          />
        ) : (
          <AccountManagementPrevAccount handleBack={handleBack} state={state} />
        )}
      </div>
    </div>
  );
}

export default AccountManagementCreateAccount;
